import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Logo } from "@/components/Logo";
import { Loader2, LogIn } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await login(email, password);
      nav("/admin", { replace: true });
    } catch (e) {
      setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center px-5" data-testid="admin-login-page">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[520px] h-[520px] rounded-full bg-[#D4AF37]/8 blur-[140px]" />
      </div>
      <form onSubmit={submit} className="relative w-full max-w-md border border-[#2A2A2A] bg-[#0F0F0F] p-8 md:p-10" data-testid="admin-login-form">
        <div className="flex flex-col items-center mb-8">
          <Logo size="lg" />
          <div className="text-[0.65rem] uppercase tracking-[0.32em] text-[#D4AF37] mt-5">Admin Panel</div>
          <h1 className="font-serif text-2xl text-white mt-2">Sign in to manage content</h1>
        </div>

        <label className="block text-xs uppercase tracking-[0.22em] text-white/55 mb-2">Email</label>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full bg-[#0A0A0A] border border-[#2A2A2A] focus:border-[#D4AF37] outline-none px-4 py-3 text-white"
          data-testid="admin-login-email"
        />

        <label className="block text-xs uppercase tracking-[0.22em] text-white/55 mb-2 mt-5">Password</label>
        <input
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full bg-[#0A0A0A] border border-[#2A2A2A] focus:border-[#D4AF37] outline-none px-4 py-3 text-white"
          data-testid="admin-login-password"
        />

        {err && (
          <div className="mt-4 text-sm text-red-400 border border-red-900/50 bg-red-950/30 p-3" data-testid="admin-login-error">
            {err}
          </div>
        )}

        <button
          type="submit"
          disabled={busy}
          className="btn-primary justify-center w-full mt-7"
          data-testid="admin-login-submit"
        >
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <LogIn className="w-4 h-4" />}
          {busy ? "Signing in…" : "Sign In"}
        </button>
      </form>
    </div>
  );
}
